<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-btn to="/" icon x-large>
          <v-icon x-large>mdi-dumbbell</v-icon>
        </v-btn>

        <v-card-title>
          Workout
        </v-card-title>
      </div>

      <v-spacer></v-spacer>

    </v-app-bar>

    <v-main>
          <router-view />
    </v-main>
  </v-app>
</template>

<script>
  export default {
    name: 'App',

    components: {
    },

    data: () => ({
    }),
  }
</script>
